import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { ExtensionType, utils, settings, extensions } from '@pixi/core';
import { LoaderParserPriority } from '@pixi/assets';
import { BitmapFont } from './BitmapFont.mjs';
import './formats/index.mjs';
import { TextFormat } from './formats/TextFormat.mjs';
import { XMLStringFormat } from './formats/XMLStringFormat.mjs';
var validExtensions = [".xml", ".fnt"];
var loadBitmapFont = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Normal
  },
  test: function test(url) {
    return validExtensions.includes(utils.path.extname(url));
  },
  testParse: function testParse(data) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", TextFormat.test(data) || XMLStringFormat.test(data));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  parse: function parse(asset, data, loader) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var fontData, src, pages, textureUrls, i, pageFile, imagePath, loadedTextures, textures;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            fontData = TextFormat.test(asset) ? TextFormat.parse(asset) : XMLStringFormat.parse(asset);
            src = data.src;
            pages = fontData.page;
            textureUrls = [];
            for (i = 0; i < pages.length; ++i) {
              pageFile = pages[i].file;
              imagePath = utils.path.join(utils.path.dirname(src), pageFile);
              textureUrls.push(imagePath);
            }
            _context2.next = 7;
            return loader.load(textureUrls);
          case 7:
            loadedTextures = _context2.sent;
            textures = textureUrls.map(function (url) {
              return loadedTextures[url];
            });
            return _context2.abrupt("return", BitmapFont.install(fontData, textures, true));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  load: function load(url, _options) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return settings.ADAPTER.fetch(url);
          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response.text());
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  unload: function unload(bitmapFont) {
    bitmapFont.destroy();
  }
};
extensions.add(loadBitmapFont);
export { loadBitmapFont };